
export class EventRequesAcknowledgeModel {
  id: number;
  requestId: number;
  requestNumber: string;
  Permission: string[];
  postedDate: Date;
  rejectReason: string;
  acknowledgeStatus: string;
  isValidFeedback: boolean;
  slaDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/core/models/event-request-acknowledge.ts